import { withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import OfferActionDialog from '../../OfferOverview/OfferActionDialog';
import { republicOfferRequestInformationMutation } from '../../../apollo';

class OfferAction extends Component {
  state = {
    open: true,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  request = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offerId,
      refetchQueries,
    } = this.props;

    const { mutate } = client;

    const variables = {
      offerId,
      message,
    };

    try {
      await mutate({
        mutation: republicOfferRequestInformationMutation,
        variables,
        refetchQueries,
      });

      this.handleClose();
      setSnackbarMessage(
        'Thank You for your interest. Someone will contact you shortly'
      );
    } catch (error) {
      this.handleClose();
      handleSnackbarError(error);
    }
  };

  requestMsg = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offerId,
      refetchQueries,
    } = this.props;

    const { mutate } = client;

    const variables = {
      offerId,
      message,
      investorRepublicId: sessionStorage.getItem('repUserId'),
    };

    try {
      await mutate({
        mutation: republicOfferRequestInformationMutation,
        variables,
        refetchQueries,
      });

      this.handleClose();
      setSnackbarMessage(
        'Thank You for your interest. Someone will contact you shortly'
      );
    } catch (error) {
      this.handleClose();
      handleSnackbarError(error);
    }
  };

  render() {
    const { open } = this.state;
    const { title, dialogBody, enableMessage, republicRequestform } =
      this.props;

    return (
      <Fragment>
        <OfferActionDialog
          open={open && republicRequestform}
          handleClose={this.handleClose}
          request={this.requestMsg}
          title={title}
          dialogBody={dialogBody}
          enableMessage={enableMessage}
        />
      </Fragment>
    );
  }
}

OfferAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dialogBody: PropTypes.string.isRequired,
  refetchQueries: PropTypes.array,
  enableMessage: PropTypes.bool.isRequired,
  linkForm: PropTypes.bool,
};

OfferAction.defaultProps = {
  refetchQueries: [],
};

export default connect()(withApollo(withAlertHandler(OfferAction)));



// WEBPACK FOOTER //
// ./src/components/RepublicOffer/RepublicRequestInformationButton/RequestInformationAction.js